import { call, put } from 'typed-redux-saga'
import { budgetApiClient } from '../../api/budgetApiClient'
import {
	GoToWhitelabelSubdomainLandingAction,
	whitelabelSubdomainDataRetrievedSuccesfully,
} from '../actions/flowEntryStatemachineActions'

export function* checkWhiteLabelSubdomainDataSaga(): Generator<
	any,
	void,
	GoToWhitelabelSubdomainLandingAction
> {
	const data = yield* call(budgetApiClient.getSubdomainData)
	if (data) {
		yield put(whitelabelSubdomainDataRetrievedSuccesfully(data))
	}
}
